module.exports = __webpack_public_path__ + "static/stoneskin-d01f0004859a0ef8481ff26c2cebd799.webp";